module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "jin-prevue-show"
    },
    on: {
      "leave": _vm.leave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "jin-prevue",
    class: {
      'jin-empty': !_vm.list.length
    },
    attrs: {
      "data-empty": "暂无预告"
    }
  }, [_c('div', {
    staticClass: "jin-wrap jin-wrap-main"
  }, [_c('div', {
    staticClass: "jin-prevue__wrap"
  }, [_c('div', {
    staticClass: "jin-slider-wrap"
  }, [(_vm.isReady) ? _c('slick', {
    ref: "slick",
    staticClass: "jin-slider",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tv-prevue"
    }, [(item.thumb) ? _c('div', {
      staticClass: "tv-prevue__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumb,
        "alt": item.title
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tv-prevue__text"
    }, [_c('div', {
      staticClass: "tv-prevue__title"
    }, [_c('span', [_vm._v(_vm._s(_vm.filterDate(item.date)))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.room_name))])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isReady) ? [_c('span', {
    staticClass: "jin-prevue__slider-button jin-slider-prev"
  }, [_c('icon', {
    attrs: {
      "type": "arrow-l"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "jin-prevue__slider-button jin-slider-next"
  }, [_c('icon', {
    attrs: {
      "type": "arrow-r"
    }
  })], 1)] : _vm._e()], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7d550b","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tv/modules/PrevueList.vue
// module id = 7NxD
// module chunks = 2 3 4 6 7 8 9